import styled from 'styled-components';

export const Flex = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;
`;
